module.exports = __webpack_public_path__ + "static/media/image001.4b4901f0.png";